import { render, staticRenderFns } from "./AdministratorUserRow.vue?vue&type=template&id=01b80361&"
import script from "./AdministratorUserRow.vue?vue&type=script&lang=ts&"
export * from "./AdministratorUserRow.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports